import Details from './Details'
import Expectation from './components/expectation'

export default Details
export { Expectation }
